export class MessageManager {
    static handleMessages() {
        setTimeout(() => document.querySelector("[data-wh-messages]")?.remove(), 5000);
    }
}